import get from 'lodash/get'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as Auth from '../../pages/auth'
import * as Members from '../../pages/members/constants'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'

const actionsToSkipDefaultErrorHandling = [
  Request.errorConstant(Auth.VALIDATE_TOKEN),
  Request.errorConstant(Members.FETCH_MEMBER_COUNTS),
]

export const epic = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<any>,
) => action$
  .filter((action) => action.type.includes(Request.ERROR))
  .filter((action) => action.type !== Constants.SHOW_FLASH_ERROR)
  .filter((action) => !actionsToSkipDefaultErrorHandling.includes(action.type))
  .map((e) => Actions.showFlashError(
    get(e, 'payload.error.response.message', Constants.DEFAULT_ERROR_MESSAGE)))

export const createFlashSuccessEpic = (event: string, message: string) =>
  (action$: ReduxObservable.ActionsObservable<Redux.Action>) =>
    action$.ofType(Request.successConstant(event))
    .mapTo(Actions.showFlashMessage(message))

export const createFlashErrorEpic = (event: string, message: string) =>
  (action$: ReduxObservable.ActionsObservable<Redux.Action>) =>
    action$.ofType(Request.errorConstant(event))
    .mapTo(Actions.showFlashError(message))



// WEBPACK FOOTER //
// ./src/components/flash-message/epic.ts